export default "__VITE_ASSET__C8ELowzj__"